import React from 'react'
import { isMobileOnly } from 'react-device-detect'

export default (SpComponent, PcComponent) => {
  class SplitSpPcComponent extends React.Component {
    render() {
      return isMobileOnly ? <SpComponent /> : <PcComponent />
    }
  }

  return SplitSpPcComponent
}
